// extracted by mini-css-extract-plugin
export default {"wrapper":"EditHolidayGeneralForm_wrapper__8AEn4","submitWrapper":"EditHolidayGeneralForm_submitWrapper__eZmI-"};